import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function Logout() {
    const navigate = useNavigate();

    const doLogout = () => {
            localStorage.removeItem("jwt_token");
            localStorage.removeItem("admin_id");
            localStorage.removeItem("admin_email");
            localStorage.removeItem("role");
            localStorage.removeItem("admin_password");
            localStorage.removeItem("admin_org");
            localStorage.removeItem("employee_email");
            localStorage.removeItem("employee_phone");
            localStorage.removeItem("employee_id");
            localStorage.removeItem("clockInTime");
            localStorage.removeItem("clockInMessage");
            localStorage.removeItem("geo_lat");
            localStorage.removeItem("geo_lng");
            localStorage.removeItem("latitude");
            localStorage.removeItem("longitude");
            localStorage.removeItem("uploadedPayrollName");
            localStorage.removeItem("uploadedPayrollDate");

            navigate("/", { replace: true });
        };

    const hasLoggedOut = useRef(false);

    useEffect(() => {
        if (hasLoggedOut.current) return;

        hasLoggedOut.current = true;
        doLogout();
    }, [navigate]);

    return null; // nothing to render
}